import { render, staticRenderFns } from "./BedsHome.vue?vue&type=template&id=3cc35184&"
import script from "./BedsHome.vue?vue&type=script&lang=js&"
export * from "./BedsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports